// extracted by css-extract-rspack-plugin
export default {"notToggleLayout":"notToggleLayout-kmYDeZ","notToggleRow":"notToggleRow-chJnve"};